import React from 'react'
import { ButtonV2, ExternalLink } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyle } from './AccordionComponents.styles'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

export type AccordionHeadingProps = {
  icon: IconDefinition
  text: React.ReactNode
  completed?: boolean
}

export const AccordionHeading: React.FC<AccordionHeadingProps> = ({
  icon,
  text,
  completed,
}) => {
  const { classes } = useStyle()
  return (
    <div className={classes.accordionHeader} data-testid="accordion-header">
      <div className={classes.accordionHeaderIcon}>
        <div
          className={
            completed
              ? classes.completedIconContainer
              : classes.accordionIconContainer
          }
          data-testid={
            completed
              ? 'accordion-completed-icon-container'
              : 'accordion-icon-container'
          }
        >
          <FontAwesomeIcon
            icon={completed ? faCheck : icon}
            className={
              completed ? classes.completedIcon : classes.accordionIcon
            }
          />
        </div>
      </div>
      <div
        className={classes.accordionHeaderText}
        data-testid="accordion-text-container"
      >
        {text}
      </div>
    </div>
  )
}

export type AccordionDescriptionProps = {
  descriptionText: React.ReactNode
  link?: string
  linkText?: string
  showButton?: boolean
  loading?: boolean
  buttonClickHandler?: () => void
}

export const AccordionDescription: React.FC<AccordionDescriptionProps> = ({
  descriptionText,
  link,
  linkText,
  showButton = false,
  loading = false,
  buttonClickHandler,
}) => {
  const { classes } = useStyle()
  return (
    <>
      <div
        className={classes.accordionDescription}
        data-testid="accordion-description"
      >
        {descriptionText}
        {link && linkText && (
          <>
            {' '}
            <ExternalLink href={link}>{linkText}</ExternalLink>
          </>
        )}
      </div>
      {showButton && (
        <div className={classes.buttonContainer}>
          <ButtonV2
            data-testid="mark-as-button"
            styleType="primary"
            onClick={buttonClickHandler}
            loading={loading}
          >
            Mark as done
          </ButtonV2>
        </div>
      )}
    </>
  )
}
